function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_b)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 306,
  height: 140,
  fill: "white",
  fillOpacity: 0.9
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M212.338 72.2896H216.028V69.1226H204.176V72.2896H208.732V78.737H203.204V81.9046H210.728L211.836 81.8824C214.574 81.9046 217.625 80.1792 217.625 80.1792V76.553C215.744 78.2579 213.212 78.675 212.337 78.7259V72.2896H212.338Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M228.42 58.6099H223.614V61.4428H228.42V58.6099Z",
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M230.679 74.3746H236.084C235.624 75.2348 234.35 76.6974 233.511 77.2711C232.496 77.9643 231.818 78.4627 230.667 78.8593V81.8897H243.292C243.292 81.8897 246.779 81.6889 248.696 81.0643C250.493 80.4796 251.004 80.2423 251.004 80.2423C251.004 80.2423 251.653 81.2474 252.008 82.0617H255.707C255.707 82.0617 255.342 80.6312 253.784 78.0279C252.448 75.7908 251.904 75.2271 251.904 75.2271H247.974C247.974 75.2271 249.145 76.8457 249.562 77.4736C249.562 77.4736 249.104 77.6473 248.058 78.0234C247.005 78.4029 245.058 78.7354 243.981 78.7354H236.52C236.535 78.742 237.715 77.7601 238.402 76.9508C238.986 76.261 239.603 75.2044 239.872 74.3746H255.723V71.207H230.679V74.3746Z",
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M268.787 76.2245V72.7593C266.749 71.7254 265.652 70.7213 265.652 70.7213C266.514 69.2698 267.22 67.2882 267.502 65.9722C267.784 64.6562 267.723 63.9071 267.172 63.1747C266.608 62.4213 265.439 62.4926 265.439 62.4926H264.685V58.6021H261.08V62.4926H258.124V65.6585H264.179C264.023 66.9121 262.921 69.1652 262.032 70.2356C260.187 72.4611 258.159 73.1991 258.159 73.1991V76.6007C258.908 76.4491 260.12 75.9794 261.081 75.3676V82.0396H264.686V74.0261C267.723 76.0381 268.787 76.2245 268.787 76.2245Z",
  fill: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M283 78.696H277.142V67.7904H282.372V64.6234H277.142V58.5947H273.536V64.6234H268.217V67.7904H273.536V78.696H267.763V81.863H283V78.696Z",
  fill: "black"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M128.943 68.673V64.6215H126.561V68.673H125.771V63.8376H129.735V68.673H128.943ZM134.305 71.6315V68.673H132.86V62.4419C132.86 62.4419 132.922 61.6962 132.398 61.1944C131.864 60.6844 131.055 60.6816 131.055 60.6816H129.275V58.5989H126.049V60.6811H124.438C124.438 60.6811 123.618 60.6523 123.124 61.1939C122.623 61.7421 122.647 62.4413 122.647 62.4413V68.6725H121.282V71.6309H122.647V76.6478C122.647 76.6478 122.665 77.3968 122.077 78.0723C121.648 78.563 121.255 78.7942 121.255 78.7942V82.0713C121.255 82.0713 122.306 81.8511 123.246 80.9738C123.825 80.4355 124.65 79.7756 125.241 78.4451C125.877 77.0129 125.772 75.4723 125.772 75.4723V71.6309H126.562V76.5765H128.944V71.6309H129.735V78.8003H127.645V82.0713H130.09C130.09 82.0713 131.207 82.0503 132.055 81.184C132.901 80.3155 132.859 79.1145 132.859 79.1145V71.6315H134.305Z",
  fill: "black"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M141.197 58.5938H137.957V60.6776H133.539V63.8452H146.267V60.6776H141.197V58.5938Z",
  fill: "black"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M143.996 78.5782H143.211V66.5209C143.211 66.5209 143.22 65.9522 142.849 65.5252C142.387 64.993 141.839 65.0472 141.839 65.0472H136.542C136.542 65.0472 135.959 65.0074 135.531 65.5108C135.14 65.9727 135.168 66.5209 135.168 66.5209V76.147C135.168 76.147 135.2 76.9087 134.614 77.6096C134.07 78.2596 133.428 78.6391 133.428 78.6391V82.0722C133.428 82.0722 134.604 81.6324 135.665 80.7866C136.809 79.8738 137.392 78.9782 137.781 78.1943C138.336 77.0758 138.292 75.9733 138.292 75.9733V68.0355H140.085V80.3479C140.085 80.3479 140.063 80.9121 140.556 81.4056C141.05 81.8996 141.802 81.9013 141.802 81.9013H144.796C144.796 81.9013 145.452 81.8675 145.862 81.4454C146.319 80.9736 146.267 80.4624 146.267 80.4624V76.3677H143.996V78.5782Z",
  fill: "black"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M101.768 71.9582H114.736V77.6827H101.768V71.9582ZM114.738 68.7929H101.769V63.0779H114.738V68.7929ZM116.341 59.8279H100.165C98.9211 59.8279 97.9126 60.8363 97.9126 62.0805V78.7741C97.9126 80.0182 98.9211 81.0267 100.165 81.0267H116.341C117.585 81.0267 118.594 80.0182 118.594 78.7741V62.0805C118.594 60.8363 117.585 59.8279 116.341 59.8279Z",
  fill: "black"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M86.9179 67.883H91.8501V70.6727H86.9179V67.883ZM91.8501 64.716H86.9179V61.9263H91.8501V64.716ZM73.7182 70.1898H79.5494V71.2348H73.7182V70.1898ZM73.7182 66.6787H79.5494V67.7237H73.7182V66.6787ZM95.2583 60.4415C95.2583 59.4264 94.4346 58.6027 93.4195 58.6027H91.8501H86.9179H85.3501C84.3333 58.6027 83.5113 59.4264 83.5113 60.4415V73.6727C83.5113 73.6727 83.5655 75.6498 82.9045 76.765V75.3107H78.2748V74.0981H80.9069C81.8086 74.0981 82.5382 73.3668 82.5382 72.4667V65.6144C82.5382 64.7127 81.8086 63.9814 80.9069 63.9814H78.2748V62.8855H82.9045V60.1577H78.2748V58.5994H74.9833V60.1577H70.3647V62.8855H74.9833V63.9814H72.2672C71.3671 63.9814 70.6358 64.7127 70.6358 65.6144V72.4667C70.6358 73.3668 71.3671 74.0981 72.2672 74.0981H74.9833V75.3107H70.3647V78.0794H74.9833V82.0718H78.2748V78.0794H81.6011C81.1724 78.398 80.835 78.5718 80.835 78.5718V82.0718C80.835 82.0718 82.5205 81.538 83.8028 80.5566C85.224 79.4701 85.7578 78.6016 86.384 76.9398C86.7408 75.9966 86.8559 74.6712 86.8968 73.8398H91.8501V78.7593H89.9687V82.0718H92.4254C92.4254 82.0718 93.4278 82.1243 94.3693 81.1618C95.3523 80.1594 95.2583 79.2406 95.2583 79.2406V60.4415Z",
  fill: "black"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M239.677 63.7936C240.325 63.2503 241.527 61.7811 241.527 61.7811H244.286C244.286 61.7811 244.588 62.1617 246.449 64.0851C247.469 65.14 248.419 65.779 249.397 66.2885H236.702C238.2 65.2866 239.218 64.1775 239.677 63.7936ZM246.177 59.1114C245.666 58.5189 244.975 58.5952 244.975 58.5952H240.946C240.224 58.5952 239.614 59.279 239.614 59.279C239.279 59.6552 237.774 61.5576 235.58 63.1663C233.384 64.7755 230.73 65.5085 230.73 65.5085V68.8094C230.73 68.8094 231.668 68.6976 233.666 67.8949V69.4566H252.484V67.8938C254.246 68.6937 255.77 68.7479 255.77 68.7479V65.5295C254.432 65.2778 251.966 64.3379 249.875 62.7702C247.786 61.2013 246.583 59.581 246.177 59.1114Z",
  fill: "black"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M223.875 77.7768C223.164 77.0665 222.495 74.9964 222.495 74.9964L219.774 65.3084H228.411V62.1425H218.883L217.897 58.6309H214.218L215.198 62.1425H203.265V65.3084H216.081L219.318 76.9199C219.318 76.9199 219.921 79.1199 222.041 80.6462C224.299 82.2714 226.455 82.0834 226.455 82.0834H228.452V78.9479H226.759C225.725 78.9473 224.878 78.7803 223.875 77.7768Z",
  fill: "black"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M197.811 75.3725C196.828 73.6581 196.328 71.9665 196.066 70.9447H200.946V67.7788H195.376V65.0577H200.444V61.8912H195.376V58.5887H191.771V61.8912H190.815C190.861 61.52 190.861 61.1489 190.861 61.0133V58.5915H187.831V61.5566C187.831 61.5566 187.852 62.2414 187.326 63.0795C187.093 63.4507 186.565 64.0736 185.897 64.3446V62.2049H182.866V58.5881H179.261V62.2049H175.791V65.3702H179.224C179.199 66.2863 179.05 68.5616 178.216 70.5133C177.4 72.4157 176.554 73.3235 175.823 73.7843V77.7036C175.823 77.7036 177.035 77.5012 178.09 76.2504C178.521 75.7392 178.926 75.175 179.261 74.6096V82.0722H182.866V71.1826C183.122 71.4393 183.434 71.691 183.868 72.0174C185.144 72.9799 186.043 73.241 186.043 73.241L186.052 69.7089C186.052 69.7089 185.217 69.3217 184.296 68.4853C183.785 68.02 183.21 67.1405 182.866 66.553V65.3708H185.561V67.8148C185.561 67.8148 186.648 67.8563 188.614 66.1342C188.992 65.8028 189.32 65.435 189.605 65.0588H191.77V67.7799H186.418V70.9459H191.136C190.897 71.8171 190.267 73.9314 189.199 75.6236C187.798 77.8397 185.729 78.8227 185.729 78.8227V82.0888C185.729 82.0888 187.672 81.7701 189.469 79.8677C190.729 78.534 191.44 77.3855 191.77 76.6669V82.0727H195.375V76.6216C195.732 77.4292 196.395 78.5528 197.56 79.8223C199.607 82.0594 200.945 82.0799 200.945 82.0799V78.6961C199.317 77.8181 197.811 75.3725 197.811 75.3725Z",
  fill: "black"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M172.168 58.5989H168.573L166.15 62.0276H163.659L161.237 58.5989H157.641L160.02 62.0276H156.612V65.1929H163.106V67.9318H157.02V71.0993H163.106V73.795H156.612V76.962H163.106V82.0713H166.711V76.962H173.512V73.795H166.711V71.0993H172.793V67.9318H166.711V65.1929H173.512V62.0276H169.789L172.168 58.5989Z",
  fill: "black"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M155.653 64.3888V61.2329C155.653 61.2329 154.461 60.5226 152.341 59.7796C150.219 59.0373 148.568 58.7551 148.568 58.7551V61.8076C148.568 61.8076 150.746 62.3669 152.219 62.883C153.586 63.3626 155.653 64.3888 155.653 64.3888Z",
  fill: "black"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M155.653 70.2045V66.991C155.653 66.991 154.403 66.2293 152.297 65.4443C149.998 64.5868 148.568 64.4148 148.568 64.4148V67.5757C148.568 67.5757 149.989 67.807 151.963 68.5587C153.289 69.0638 155.653 70.2045 155.653 70.2045Z",
  fill: "black"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M151.43 76.0262C150.86 76.9567 150.02 78.0271 148.536 78.6533V82.087C148.536 82.087 151.703 81.6013 153.803 78.3253C153.803 78.3253 155.423 76.2077 155.778 72.1323H152.719C152.719 72.1323 152.453 74.3567 151.43 76.0262Z",
  fill: "black"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M35.9463 57.7102L23 82.0882H49.162L48.1536 80.2367H26.0907L37.0151 59.6591L35.9463 57.7102Z",
  fill: "#E8382C"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M36.3638 57H42.5357L56.0745 82.0833H49.9025L36.3638 57Z",
  fill: "#E8382C"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M44.5508 57H50.7244L64.2615 82.0833H58.0896L44.5508 57Z",
  fill: "#E8382C"
});

var _ref23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_b",
  x: -4,
  y: -4,
  width: 314,
  height: 148,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur",
  result: "shape"
})));

function SvgLogoAeroasahi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 140,
    viewBox: "0 0 306 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAeroasahi);
export default __webpack_public_path__ + "static/media/logo_aeroasahi.c54c14e1.svg";
export { ForwardRef as ReactComponent };